/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {RuleFormComponent as ɵc} from './rule-form/rule-form.component';
export {RuleComponent as ɵb} from './rule.component';
export {declaration as ɵa} from './rule.module';
export {RuleRoutes as ɵd} from './rule.routing';